var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container cofig-box" },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: {
              headerList: [
                { label: "系统管理", url: "" },
                { label: "全局配置", url: "" }
              ]
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "cofig-top" }, [
        _c(
          "div",
          { staticClass: "cofig-tabs" },
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              _vm._l(_vm.configuredSyslist, function(item, i) {
                return _c("el-tab-pane", {
                  key: i,
                  attrs: {
                    label: item.systemName ? item.systemName : "默认配置",
                    name: item.systemId
                  }
                })
              }),
              1
            ),
            _c("add-icon", {
              staticStyle: {
                "margin-left": "40px",
                "margin-bottom": "5px",
                width: "20px",
                height: "20px",
                cursor: "pointer"
              },
              attrs: { slot: "label" },
              on: {
                click: function($event) {
                  return _vm.addsystem()
                }
              },
              slot: "label"
            })
          ],
          1
        ),
        _c("div", { staticClass: "config-title" }, [
          _c("span", [_vm._v(_vm._s(_vm.getsystemname(_vm.activeName)))]),
          _c("input", {
            staticClass: "btn btn-red add-btn",
            attrs: { type: "button", value: "新增" },
            on: { click: _vm.addcofig }
          })
        ])
      ]),
      _c(
        "div",
        { staticClass: "log-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.ConfigData,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
                height: _vm.tableheight,
                border: ""
              }
            },
            [
              _c("template", { slot: "empty" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("no-data", {
                      attrs: { height: "400px", width: "400px" }
                    })
                  ],
                  1
                )
              ]),
              _c("el-table-column", {
                attrs: {
                  prop: "bindDictName",
                  label: "配置名称",
                  "min-width": "80"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.bindDictName)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.bindDictName))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "module", label: "展示类型", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.value.configValue)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.value.configValue))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "50", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            ref: "config-" + scope.row.id,
                            attrs: {
                              placement: "right",
                              width: "200",
                              trigger: "click",
                              "popper-class": "table-popper"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "op-tips" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "op-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.editconfig(scope, true)
                                      }
                                    }
                                  },
                                  [
                                    _c("operate-edit-icon", {
                                      staticClass: "svgOperateIcon"
                                    }),
                                    _vm._v(" 编辑")
                                  ],
                                  1
                                ),
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: { title: "确定删除此条权限吗？" },
                                    on: {
                                      onConfirm: function($event) {
                                        return _vm.confirmdel(scope, true)
                                      },
                                      onCancel: function($event) {
                                        return _vm.confirmdel(scope, false)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "op-item ",
                                        attrs: { slot: "reference" },
                                        slot: "reference"
                                      },
                                      [
                                        _c("delIcon", {
                                          staticClass: "svgOperateIcon"
                                        }),
                                        _vm._v(" 删除")
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c("operate", {
                              staticClass: "operate-icon",
                              attrs: { slot: "reference" },
                              slot: "reference"
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _vm.showaddcofig
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "dialog_footer_btn",
              attrs: {
                width: "560px",
                title: _vm.dialogtitle,
                visible: _vm.showaddcofig
              },
              on: {
                "update:visible": function($event) {
                  _vm.showaddcofig = $event
                }
              }
            },
            [
              _c("add-config", {
                attrs: {
                  notaddsystem: _vm.notaddsystem,
                  optionallist: _vm.optionallist,
                  iseditconfig: _vm.iseditconfig,
                  canaddsystemlist: _vm.canaddsystemlist,
                  configval: _vm.configval,
                  configvaluekey: _vm.configvaluekey
                },
                on: {
                  AddconfigSubmit: _vm.AddconfigSubmitFn,
                  Addconfigsystem: _vm.AddconfigsystemFn
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }